export function bookingChipTitle(booking: {
  event_type?: string | null
  private_details_visible?: boolean
  title?: string | null
  service_emoji?: string | null
  service_name?: string | null
  client_name?: string | null
}): string {
  if (booking.event_type === "time_block") {
    return booking.private_details_visible
      ? booking.title || "Ocupado"
      : "Ocupado (Google Calendar)"
  }

  const client = booking.client_name || "Cliente"
  const service = booking.service_name?.trim()
  const name = service ? `${client} · ${service}` : client
  return booking.service_emoji ? `${booking.service_emoji} ${name}` : name
}
